export default "__VITE_ASSET__BUclk79B__"